export const defaultPlaceholder = '-';

export const ifNullOrEmpty = (
	value: string | undefined | null,
	defaultValue = defaultPlaceholder
): string => {
	if (typeof value !== 'string' || value.trim() === '') {
		return defaultValue;
	}
	return value ?? defaultValue;
};

export const escapeHtml = (s: string) =>
	s.replace(
		/[&<>"']/g,
		(m) =>
			({
				'&': '&amp;',
				'<': '&lt;',
				'>': '&gt;',
				'"': '&quot;',
				"'": '&#39;',
			})[m] || m
	);

/**
 * Change the first character in the string to uppercase. Leave
 * the rest untouched
 * @param value The string
 * @returns
 */
const capitalizeString = (value: string): string => {
	return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};

/**
 * Change the first in the string to lowercase. Leave the rest
 * untouched
 * @param value
 * @returns
 */
const decapitalizeString = (value: string): string => {
	return `${value.charAt(0).toLowerCase()}${value.slice(1)}`;
};

export { capitalizeString, decapitalizeString };
